import React, {
  PropsWithChildren,
  ReactElement,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react'

import * as S from './styles'

type ExpandedPanelProps = {
  header: ReactNode
  icon?: ReactElement
  open: boolean
  onExpand: () => void
}
export const ExpandedPanel = ({
  open,
  header,
  children,
  icon,
  onExpand,
}: PropsWithChildren<ExpandedPanelProps>) => {
  const [expanded, setExpanded] = useState(open)

  const [height, setHeight] = useState(0)
  const ref = useRef<HTMLDivElement>(null)

  const headerIcon =
    icon &&
    React.Children.map(icon, (child) =>
      React.cloneElement(child, {
        style: {
          transition: 'transform 300ms ease-in-out 0s',
          transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
        },
      }),
    )
  useEffect(() => {
    if (ref?.current?.clientHeight) {
      setHeight(ref?.current?.clientHeight)
    }
  }, [expanded])
  return (
    <S.Container>
      <S.Header
        onClick={() => {
          if (expanded === false) {
            onExpand()
          }
          setExpanded(!expanded)
        }}
      >
        {header}

        {icon && headerIcon}
      </S.Header>
      <S.ExpandedPanel style={{ maxHeight: expanded ? height : '0px' }}>
        <div ref={ref}>{children}</div>
      </S.ExpandedPanel>
    </S.Container>
  )
}
